import * as React from 'react';
export const IcBrainStroke = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 12c0-1.31-.85-2.41-2.02-2.82 0-.06.02-.12.02-.18 0-1.66-1.34-3-3-3-.24 0-.48.04-.7.09A2.986 2.986 0 0014 5c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78-.93 0-1.75.43-2.3 1.09C7.47 6.04 7.24 6 7 6 5.34 6 4 7.34 4 9c0 .06.01.12.02.18C2.85 9.59 2 10.69 2 12c0 1.66 1.34 3 3 3h4.01c0 1.66 1.33 3 2.99 3h1v2c0 .55.45 1 1 1s1-.45 1-1v-.17c0-1.01.82-1.83 1.83-1.83 1.62 0 3.08-1.22 3.17-2.84 0-.12-.01-.23-.02-.34C21.15 14.41 22 13.31 22 12zm-5.55.11c.29.14.49.42.54.73.05.32-.05.64-.28.87l-2 2c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.02-1.02-.76-.38a.99.99 0 01-.54-.73c-.05-.32.05-.64.28-.87l2-2a.996.996 0 111.41 1.41l-1.02 1.02.76.38h.01z'
      fill='currentColor'
    />
  </svg>
);
